module.exports = __webpack_public_path__ + "assets/img/myInfo.cf639862.png";